import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Icon } from "@iconify/react";

// Mali switcher u Header-u — flag + skraćenica jezika.
// Persistira u localStorage kroz i18next-browser-languagedetector (busgo_lang ključ).

const LANGUAGES = [
    { code: "sr", label: "Srpski", flag: "twemoji:flag-serbia", short: "SR" },
    { code: "en", label: "English", flag: "twemoji:flag-united-kingdom", short: "EN" },
];

// `light` — na providnom hero header-u tekst mora biti beo; posle skrola
// header pozadini i prosleđuje tamnu varijantu (kao dugme Pomoć).
export default function LanguageSwitcher({ size = "medium", light = false }) {
    const { i18n, t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const currentCode = (i18n.resolvedLanguage || i18n.language || "sr").substring(0, 2);
    const current = LANGUAGES.find((l) => l.code === currentCode) || LANGUAGES[0];

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleSelect = (code) => {
        i18n.changeLanguage(code);
        handleClose();
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                size={size}
                aria-label={t("common.language")}
                sx={{
                    gap: 0.5,
                    color: light ? "white" : "text.primary",
                    transition: "color 0.3s ease",
                }}
            >
                <Icon icon={current.flag} width={size === "small" ? 18 : 22} />
                <Typography
                    variant="caption"
                    sx={{ fontWeight: 700, fontSize: size === "small" ? "0.7rem" : "0.75rem" }}
                >
                    {current.short}
                </Typography>
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {LANGUAGES.map((lang) => (
                    <MenuItem
                        key={lang.code}
                        onClick={() => handleSelect(lang.code)}
                        selected={lang.code === currentCode}
                    >
                        <ListItemIcon>
                            <Icon icon={lang.flag} width={20} />
                        </ListItemIcon>
                        <ListItemText>{lang.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
